import { render } from "./OutOfService.vue?vue&type=template&id=b891117c&scoped=true&ts=true"
import script from "./OutOfService.vue?vue&type=script&lang=ts"
export * from "./OutOfService.vue?vue&type=script&lang=ts"

import "./OutOfService.vue?vue&type=style&index=0&id=b891117c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\pen-tutoring\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b891117c"]])

export default __exports__